<template>
  <el-row class="articleContent">
    <el-col :span="24">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/public-service' }"
          >公共服务</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/public-service' }"
          >信息查询服务</el-breadcrumb-item
        >
        <el-breadcrumb-item>{{ regulations.laws }}</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="grid-content bg-purple-dark">
        <p class="tlt1">{{ regulations.laws }}</p>
        <!-- <p class="tlt3">
          浏览次数：<span>{{ regulations.num }}</span>
        </p> -->
        <p class="tlt2">（数据来源：国家文物局考古司）</p>
        <div class="hxl_title"></div>
      </div>
      <div class="announcement">
        <div class="ipt">
          <el-input
            v-model="searchOn"
            maxlength="24rem"
            placeholder="请输入单位名称"
            class="input-with-select"
          >
            <el-button
              class="searchFor"
              slot="append"
              size="small"
              @click="seeSer()"
              >搜索</el-button
            >
          </el-input>
          <el-button size="small" class="reset" @click="resetOn()"
            >重置</el-button
          >
        </div>
        <div class="dat">
          <div class="paging">
            <el-select
              v-model="province"
              clearable
              placeholder="省份"
              class="province"
              @change="provinceChange()"
            >
              <el-option
                v-for="item in provinceList"
                :key="item.id"
                :label="item.name"
                :value="item.code"
              >
              </el-option>
            </el-select>
            <!-- <el-select
              v-model="nature"
              clearable
              placeholder="状态"
              class="nature"
              @change="natureChange()"
            >
              <el-option
                v-for="item in natureList"
                :key="item.id"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select> -->
          </div>
          <div>
            <el-button
              size="small"
              icon="el-icon-refresh"
              class="refresh"
              @click="refresh()"
              >刷新</el-button
            >
          </div>
        </div>
        <div style="padding: 0 20px; text-align: center">
          <el-table
            :data="legalForms"
            :stripe="true"
            border
            fit
            style="width: 100%"
            :header-cell-style="{
              background: '#ebe6db',
              color: '#585856',
              borderColor: '#585856',
            }"
            :cell-style="{ borderColor: '#585856' }"
          >
            <el-table-column
              align="center"
              type="index"
              :index="count"
              label="总序"
              width="60"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="kgfjzzdwSf"
              label="省份"
              min-width="105px"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="kgfjzzdwDwmc"
              label="单位名称"
              min-width="150px"
            >
            </el-table-column>

            <el-table-column
              align="center"
              prop="kgfjzzdwDwdz"
              label="单位地址"
              min-width="80px"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="kgfjzzdwBgdh"
              label="办公电话"
              min-width="100px"
            >
            </el-table-column>
            <!-- <el-table-column
              align="center"
              prop="kgfjzzdwFrdb"
              label="法人代表"
              min-width="90px"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="isdisable"
              label="是否禁用"
              min-width="100px"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.isdisable === "0" ? "启用" : "禁用" }}</span
                >   
              </template>
            </el-table-column> -->
          </el-table>
          <el-pagination
            popper-class="pageclass"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 40, 80]"
            :page-size="pagesize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </el-col>
  </el-row>
</template>
<script>
import {
  URL_COMPREHENSIVE_EXCUSE,
  URL_DATAKGFJ_ZZDWS,
  URL_PROVINCE_LIST,
} from "../../../utils/api";
import util from "../../../utils/util";
import { frontHeater } from "../../../utils/md5encryption";
export default {
  inject: ["reload"],
  props: [],
  components: {},
  data() {
    return {
      // 基本数据
      regulations: {
        //  标题+面包屑
        laws: "",
        // 浏览次数
        num: "2",
      },
      // 省份
      provinceList: [],
      //省份
      province: null,
      //性质
      natureList: [
        {
          id: "1",
          value: "0",
          label: "启用",
        },
        {
          id: "2",
          value: "1",
          label: "禁用",
        },
      ],
      //性质
      nature: null,
      // 质量等级
      gradeList: [],
      // 质量等级
      grade: null,
      //   搜索
      searchOn: null,
      // 表格
      legalForms: [],
      //  根据传值判断是否免费  1是
      sta: 1,
      // 前往页数
      currentPage: 1,
      // 总条数
      total: 100,
      // 页大小
      pagesize: 10,
    };
  },
  computed: {},
  methods: {
    // 请求列表数据
    getList() {
      let result = frontHeater([""], [""]);
      let Url = util.getAjaxUrl("axiosTWo");
      let params = {
        pageNumber: this.currentPage,
        pageSize: this.pagesize,
        args: this.searchOn,
        provinceName: this.province,
        isDisable: this.nature,
      };
      this.$http.defaults.headers.common["secretTime"] = result.timeStamp;
      this.$http.defaults.headers.common["secretSign"] =
        result.encryptionString;
      this.$http.defaults.headers.common["secretDefinite"] =
        result.parameterKey;
      this.$http.defaults.headers.common["appCode"] = result.secret;
      this.$http.defaults.headers.common["districtCode"] = this.province;
      this.$http.post(Url + URL_DATAKGFJ_ZZDWS, params).then((res) => {
        if (res.status == 200) {
          console.log(res.data);
          this.legalForms = res.data.data;
          this.total = res.data.recordsTotal;
        }
      });
    },
    //获取省份
    getProvinceList() {
      let result = frontHeater(["ClassCode"], ["DistrictCode"]);
      let Url = util.getAjaxUrl("axiosTWo");
      let params = {
        ClassCode: "DistrictCode",
      };
      this.$http.defaults.headers.common["secretTime"] = result.timeStamp;
      this.$http.defaults.headers.common["secretSign"] =
        result.encryptionString;
      this.$http.defaults.headers.common["secretDefinite"] =
        result.parameterKey;
      this.$http.defaults.headers.common["appCode"] = result.secret;
      this.$http.defaults.headers.common["ClassCode"] = "DistrictCode";
      this.$http.post(Url + URL_COMPREHENSIVE_EXCUSE, params).then((res) => {
        if (res.status == 200) {
          this.provinceList = res.data.data;
        }
      });
    },
    // 获取浏览次数
    getNumberViews() {
      let result = frontHeater(["dataType"], ["DataCollection"]);
      let Url = util.getAjaxUrl("axiosTWo");
      let params = {
        dataType: "DataCollection",
      };
      this.$http.defaults.headers.common["secretTime"] = result.timeStamp;
      this.$http.defaults.headers.common["secretSign"] =
        result.encryptionString;
      this.$http.defaults.headers.common["secretDefinite"] =
        result.parameterKey;
      this.$http.defaults.headers.common["appCode"] = result.secret;
      this.$http.defaults.headers.common["dataType"] = "DataCollection";
      this.$http.post(Url + `/api/description/find`, params).then((res) => {
        if (res.status === 200) {
          this.regulations.num = res.data.data.viewTimes;
        }
      });
    },
    // 省份改变
    provinceChange() {
      this.getList();
    },
    // 性质改变
    // natureChange() {
    //   this.getList();
    // },
    // 搜索
    seeSer() {
      this.getList();
    },
    // 重置
    resetOn() {
      this.searchOn = null;
      this.province = null;
      this.nature = null;
      this.grade = null;
      this.currentPage = 1;
      this.getList();
    },
    // 解决换页后index从1开始
    count(index) {
      return (this.currentPage - 1) * this.pagesize + index + 1;
    },
    // 刷新
    refresh() {
      this.resetOn();
    },
    // 表格分页
    handleSizeChange(val) {
      this.pagesize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },
  },
  mounted() {
    this.regulations.laws = this.$route.query.title;
    this.getList();
    this.getProvinceList();
  },
};
</script>
<style scoped lang='less'>
@import "../../../styles/theme";
@import "../../../styles/comSty";
@import "../../../styles/Hierarchy";
.tlt1 {
  font-size: 18px;
  font-weight: 700;
  color: #b71c1c;
  margin: 10px 0;
  text-align: center;
}
.tlt2 {
  margin: 0;
  text-align: center;
  font-size: 16px;
}
.tlt3 {
  margin: 0 auto;
  padding-right: 40px;
  text-align: right;
  font-size: 16px;
  color: #444;
  font-weight: 700;
  span {
    color: @theme-color;
  }
}
.hxl_title {
  font-size: 22px;
  padding-bottom: 10px;
  color: #b71c1c;
  border-bottom: 3px solid #b71c1c;
}

.dat {
  display: flex;
  justify-content: space-between;
  padding: 0 20px;
  margin: 10px 0;
  align-items: center;
}
</style>
